<template>
  <b-tabs pills v-model="tabIndex">
    <b-tab key="Monitoring" title="Monitoring">
      <p/>
      <b-card no-body>
        <b-card-body>
          <b-container fluid="xl">
            <div style="display: flex;">
              <div style="flex: 1.5;">
                <base-button size="sm" type="neutral" @click.native="refreshData" style="float: right;">Refresh</base-button>
              </div>
            </div>
            <p/>
            <b-row>
              <b-col cols="12">
                <monitoring-card v-for="(item, index) in assetMonitorings" :type="type" :assetMonitoringData="item"></monitoring-card>
              </b-col>
            </b-row>
          </b-container>
        </b-card-body>
      </b-card>
    </b-tab>
    <b-tab key="Requests" title="Requests" lazy>
      <p/>
      <b-row>
        <b-col cols="12">
          <b-card no-body v-if="createAssetMonitoringRequest">
            <b-card-header>
              <h5 class="h3 mb-0">Create asset monitoring request</h5>
            </b-card-header>
            <b-card-body>
              <validation-observer v-slot="{ invalid, validate, pristine }" ref="assetMonitoringRequestFormValidator">
              <form @submit.prevent="handleSaveAssetMonitoringRequest">
                <b-container fluid="xl">
                  <b-row>
                    <b-col cols="3">
                      <div>
                        <ValidationProvider rules="frequency" v-slot="{ errors, validate, pristine }" immediate>
                          <base-input type="number" label="Tracing frequency (s)" v-model.number="form.tracingFrequency" :required=true />
                          <p class="error">{{ errors[0] }}</p>
                        </ValidationProvider>
                        <base-input label="Video live-feed">
                          <b-form-checkbox class="mb-3" v-model="form.liveFeed" />
                        </base-input>
                      </div>
                    </b-col>
                    <b-col cols="3" v-if="form.liveFeed">
                      <div>
                        <base-input label="Camera front">
                          <b-form-checkbox class="mb-3" v-model="form.cameraFront" @change="updateFormCameraMask" />
                        </base-input>
                        <base-input label="Camera rear">
                          <b-form-checkbox class="mb-3" v-model="form.cameraRear" @change="updateFormCameraMask" />
                        </base-input>
                      </div>
                    </b-col>
                    <b-col cols="3" v-if="form.liveFeed">
                      <div>
                        <base-input label="Camera left">
                          <b-form-checkbox class="mb-3" v-model="form.cameraLeft" @change="updateFormCameraMask" />
                        </base-input>
                        <base-input label="Camera right">
                          <b-form-checkbox class="mb-3" v-model="form.cameraRight" @change="updateFormCameraMask" />
                        </base-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="6">
                      <div>
                        <ValidationProvider
                          ref="liveFeedCameraSelectedProvider"
                          rules="liveFeedCameraSelected"
                          vid="liveFeedCameraSelected"
                          v-if="form.liveFeed"
                          v-slot="{ errors, validate, pristine }"
                          immediate
                        >
                          <base-input :hidden="true" v-model="assetMonitoringRequest.liveFeedCameraMask" />
                          <p class="error">{{ errors[0] }}</p>
                        </ValidationProvider>
                        <base-button size="sm" type="neutral" @click.native="handleSaveAssetMonitoringRequest" :disabled="invalid || pristine">Save</base-button>
                        <base-button size="sm" type="neutral" @click.native="handleCancelAssetMonitoringRequest">Cancel</base-button>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
      <b-card no-body>
        <b-card-body>
          <b-container fluid="xl">
            <div style="display: flex;">
              <div style="flex: 1.5;">
                <base-button size="sm" type="neutral" @click.native="refreshData" style="float: right;">Refresh</base-button>
                <base-button size="sm" type="neutral" :disabled="activeAssetMonitoring" @click.native="handleCreateAssetMonitoringRequest" style="float: right;">Create monitoring request</base-button>
              </div>
            </div>
            <time-line type="one-side" v-if="this.assetMonitoringRequests && this.assetMonitoringRequests.length > 0">
              <time-line-item v-for="(r, rIdx) in this.assetMonitoringRequests"
                              badge-type="info"
                              badge-icon="ni ni-bell-55">
                <div>
                  <b>Request details</b>
                </div>
                <div>
                  Request date/time : {{ $formatDate(new Date(r.timestamp)) }} {{ $formatTime(new Date(r.timestamp)) }}
                </div>
                <div>
                  Tracing frequency (s) : {{ r.tracingFrequency }}
                </div>
                <div>
                  Video live-feed : {{ r.liveFeed }}
                </div>
                <div v-if="r.liveFeed">
                  Cameras : {{ $getCamerasFromMask(r.liveFeedCameraMask) }}
                </div>
                <div>
                  Synced with device : {{ r.syncedWithDevice !== undefined }}
                </div>
              </time-line-item>
            </time-line>
          </b-container>
        </b-card-body>
      </b-card>
    </b-tab>
  </b-tabs>
</template>

<script>
import crudApi from "../../crud/crud-api";
import MonitoringCard from "./AssetMonitoringCard";
import { TimeLine, TimeLineItem } from '@/components';
import MonitoringView from "../ControlRoom/MonitoringView";
import { ValidationObserver } from 'vee-validate';
import { ValidationProvider, extend } from 'vee-validate';

extend('liveFeedCameraSelected', {
  validate (value) {
    return Number(value) > 0
  },
  message: 'At least one camera must be selected.'
})
extend('frequency', {
  validate (value) {
    return Number(value) >= 5 && Number(value) <= 120
  },
  message: 'The duration must be between 5 and 120 seconds (2 minutes).'
})

export default {
  name: "entity-monitorings",
  components: {
    TimeLine,
    TimeLineItem,
    MonitoringView,
    MonitoringCard,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    }
  },
  data: _ => ({
    tabIndex: 0,
    activeAssetMonitoring: undefined,
    assetMonitorings: undefined,
    assetMonitoringRequest: undefined,
    assetMonitoringRequests: undefined,
    createAssetMonitoringRequest: false,
    form: undefined,
  }),
  created() {
    this.getAssetMonitorings()
  },
  watch: {
    '$store.state.filter.update': function () {
      this.refreshData()
    },
    'tabIndex': function () {
      console.log('tabIndex is now => ' + this.tabIndex)

      this.refreshData()
    },
  },
  methods: {
    refreshData() {
      if (this.tabIndex === 0) {
        this.getAssetMonitorings()
      }
      if (this.tabIndex === 1) {
        this.getAssetMonitoringRequests()
      }
    },
    getAssetMonitorings() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      crudApi.getAssetMonitorings(this.entityId, fromTime, untilTime).then(json => this.assetMonitorings = json.data ? json.data.slice().reverse() : json);
      crudApi.getActiveAssetMonitoring(this.entityId).then(json => this.activeAssetMonitoring = json.data ? json.data : json).catch(error => this.activeAssetMonitoring = error.response.status === 404 ? undefined : this.activeAssetMonitoring);
    },
    getAssetMonitoringRequests() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      crudApi.getAssetAssetMonitoringRequests(this.entityId, fromTime, untilTime).then(json => this.assetMonitoringRequests = json.data ? json.data.slice().reverse() : json);
      crudApi.getActiveAssetMonitoring(this.entityId).then(json => this.activeAssetMonitoring = json.data ? json.data : json).catch(error => this.activeAssetMonitoring = error.response.status === 404 ? undefined : this.activeAssetMonitoring);
    },
    handleCreateAssetMonitoringRequest() {
      this.assetMonitoringRequest = {
        "assetId": this.entityId,
        "tracingFrequency": 5,
        "liveFeed": true,
        "liveFeedCameraMask": 0,
      }

      this.form = {
        "tracingFrequency": 5,
        "liveFeed": true,
        "cameraFront": false,
        "cameraRear": false,
        "cameraLeft": false,
        "cameraRight": false,
        "cameraDriver": false,
      }

      this.createAssetMonitoringRequest = true

      this.$nextTick(() => {
        if (this.$refs.assetMonitoringRequestFormValidator) {
          this.$refs.assetMonitoringRequestFormValidator.validate()
        }
      })
    },
    updateFormCameraMask() {
      this.assetMonitoringRequest.liveFeedCameraMask = this.getFormCameraMask()

      this.$refs.liveFeedCameraSelectedProvider.validate(this.assetMonitoringRequest.liveFeedCameraMask)
    },
    async handleSaveAssetMonitoringRequest() {
      let ok = await this.$refs.assetMonitoringRequestFormValidator.validate()
      if (!ok) return

      this.assetMonitoringRequest.tracingFrequency = this.form.tracingFrequency
      this.assetMonitoringRequest.liveFeed = this.form.liveFeed
      this.assetMonitoringRequest.liveFeedCameraMask = this.getFormCameraMask()

      if (this.type === 'ASSET') {
        crudApi.createAssetAssetMonitoringRequest(this.entityId, this.assetMonitoringRequest)
      }

      this.assetMonitoringRequest = undefined
      this.createAssetMonitoringRequest = false
    },
    handleCancelAssetMonitoringRequest() {
      this.assetMonitoringRequest = undefined
      this.createAssetMonitoringRequest = false
    },
    getFormCameraMask() {
      let mask = 0;

      if (this.form.cameraFront) {
        mask = mask | 1;
      }
      if (this.form.cameraRear) {
        mask = mask | 2;
      }
      if (this.form.cameraLeft) {
        mask = mask | 4;
      }
      if (this.form.cameraRight) {
        mask = mask | 8;
      }
      if (this.form.cameraDriver) {
        mask = mask | 16;
      }

      return mask;
    },
  }
}
</script>

<style scoped>

</style>
